import { render, staticRenderFns } from "./accomodationPage.vue?vue&type=template&id=8f1b2850&"
import script from "./accomodationPage.vue?vue&type=script&lang=js&"
export * from "./accomodationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports